var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select-typeahead-container",attrs:{"id":_vm.prettyContainerUid}},[_c('select',{staticStyle:{"width":"100%","display":"block"},attrs:{"id":_vm.prettyUid}})])
}
var staticRenderFns = []

export { render, staticRenderFns }